import { z } from 'zod';

import {
  CashRoundingApplicationModeSchema,
  CashRoundingModeSchema,
  PurchaseCompanySettingsSnapshotSchema,
  PurchaseOperatingModeSchema,
  PurchaseSettingsSnapshotSchema,
} from './purchases.schema.js';
import type {
  GetPurchaseCompanySettingsRequest,
  GetPurchaseCompanySettingsResponse,
  GetPurchaseSettingsRequest,
  GetPurchaseSettingsResponse,
  UpdatePurchaseCompanySettingsRequest,
  UpdatePurchaseCompanySettingsResponse,
  UpdatePurchaseSettingsRequest,
  UpdatePurchaseSettingsResponse,
} from './purchases-settings.dto.js';

export const GetPurchaseSettingsRequestSchema: z.ZodType<GetPurchaseSettingsRequest> = z.object({
  companyId: z.uuid(),
  storeId: z.uuid(),
  locationId: z.uuid(),
  stationId: z.uuid(),
});

export const GetPurchaseSettingsResponseSchema: z.ZodType<GetPurchaseSettingsResponse> = z.object({
  settings: PurchaseSettingsSnapshotSchema,
});

export const UpdatePurchaseSettingsRequestSchema: z.ZodType<UpdatePurchaseSettingsRequest> = z.object({
  companyId: z.uuid(),
  storeId: z.uuid(),
  locationId: z.uuid(),
  stationId: z.uuid(),
  mode: PurchaseOperatingModeSchema,
});

export const UpdatePurchaseSettingsResponseSchema: z.ZodType<UpdatePurchaseSettingsResponse> = z.object({
  settings: PurchaseSettingsSnapshotSchema,
});

export const GetPurchaseCompanySettingsRequestSchema: z.ZodType<GetPurchaseCompanySettingsRequest> =
  z.object({
    companyId: z.uuid(),
  });

export const GetPurchaseCompanySettingsResponseSchema: z.ZodType<GetPurchaseCompanySettingsResponse> =
  z.object({
    settings: PurchaseCompanySettingsSnapshotSchema,
  });

export const UpdatePurchaseCompanySettingsRequestSchema: z.ZodType<UpdatePurchaseCompanySettingsRequest> =
  z.object({
    companyId: z.uuid(),
    cashRoundingEnabled: z.boolean(),
    cashRoundingIncrement: z.number().positive(),
    cashRoundingMode: CashRoundingModeSchema,
    cashRoundingApplicationMode: CashRoundingApplicationModeSchema,
  });

export const UpdatePurchaseCompanySettingsResponseSchema: z.ZodType<UpdatePurchaseCompanySettingsResponse> =
  z.object({
    settings: PurchaseCompanySettingsSnapshotSchema,
  });
